import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@bfly/ui/Button';
import Form from '@bfly/ui/Form';
import Modal from '@bfly/ui/Modal';

import TaskDefinitionControl from './TaskDefinitionControl';

function JsonTaskDefinitionModal({ onHide, ...modalProps }) {
  return (
    <Modal {...modalProps} backdrop>
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage
            id="jsonModal.title"
            defaultMessage="Task Definition JSON"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Field
          name="definition"
          label="Task Definition"
          events="onChange" // don't validate
          rows="20"
        >
          {({ value, onChange, ...props }) => (
            <TaskDefinitionControl
              {...props}
              value={JSON.stringify(value, null, 2)}
              onChange={(val) => onChange(JSON.parse(val))}
            />
          )}
        </Form.Field>
      </Modal.Body>
      <Modal.Footer>
        <Modal.ButtonGroup>
          <Button onClick={onHide}>
            <FormattedMessage id="jsonModal.close" defaultMessage="Close" />
          </Button>
        </Modal.ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}

export default JsonTaskDefinitionModal;
